export const addtofavreq="addtofavreq"
export const addtofavsucc="addtofavsucc"
export const addtofavfail="addtofavfail"